import React from 'react';
import { XIcon, GitCommitIcon, CheckCircleIcon } from 'lucide-react';
interface EndpointHistoryModalProps {
  endpointId: number;
  onClose: () => void;
}
interface VersionHistory {
  version: string;
  date: string;
  status: 'deployed' | 'withdrawn' | 'development';
  changes: string[];
  author: string;
}
export const EndpointHistoryModal: React.FC<EndpointHistoryModalProps> = ({
  endpointId,
  onClose
}) => {
  // Sample version history data
  const versionHistory: VersionHistory[] = [{
    version: 'v2',
    date: '2023-11-10',
    status: 'development',
    changes: ['Updated schema validation', 'Added new field mappings', 'Enhanced error handling'],
    author: 'John Doe'
  }, {
    version: 'v1',
    date: '2023-10-15',
    status: 'deployed',
    changes: ['Initial implementation', 'Basic field mappings', 'Standard validation rules'],
    author: 'Jane Smith'
  }];
  return <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center" data-id="element-1089">
      <div className="bg-white rounded-lg w-full max-w-3xl max-h-[90vh] overflow-hidden" data-id="element-1090">
        <div className="flex justify-between items-center px-6 py-4 border-b border-gray-200" data-id="element-1091">
          <h2 className="text-xl font-semibold text-gray-800" data-id="element-1092">
            Version History
          </h2>
          <button onClick={onClose} className="text-gray-500 hover:text-gray-700" data-id="element-1093">
            <XIcon size={24} data-id="element-1094" />
          </button>
        </div>
        <div className="overflow-y-auto p-6 max-h-[calc(90vh-120px)]" data-id="element-1095">
          <div className="relative" data-id="element-1096">
            {versionHistory.map((version, index) => <div key={version.version} className="relative pb-8" data-id="element-1097">
                {index < versionHistory.length - 1 && <div className="absolute left-4 top-8 bottom-0 w-0.5 bg-gray-200" data-id="element-1098" />}
                <div className="relative flex items-start" data-id="element-1099">
                  <div className="flex items-center justify-center w-8 h-8 rounded-full bg-blue-100 ring-8 ring-white" data-id="element-1100">
                    <GitCommitIcon size={16} className="text-blue-600" data-id="element-1101" />
                  </div>
                  <div className="ml-4 flex-1" data-id="element-1102">
                    <div className="flex items-center justify-between" data-id="element-1103">
                      <h3 className="text-lg font-medium text-gray-900" data-id="element-1104">
                        {version.version}
                      </h3>
                      <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${version.status === 'deployed' ? 'bg-green-100 text-green-800' : 'bg-yellow-100 text-yellow-800'}`} data-id="element-1105">
                        {version.status === 'deployed' && <CheckCircleIcon size={12} className="mr-1" data-id="element-1106" />}
                        {version.status.toUpperCase()}
                      </span>
                    </div>
                    <p className="mt-1 text-sm text-gray-500" data-id="element-1107">
                      Released on {version.date} by {version.author}
                    </p>
                    <div className="mt-2 space-y-1" data-id="element-1108">
                      {version.changes.map((change, i) => <p key={i} className="text-sm text-gray-600" data-id="element-1109">
                          • {change}
                        </p>)}
                    </div>
                  </div>
                </div>
              </div>)}
          </div>
        </div>
      </div>
    </div>;
};